import Alpine from 'alpinejs'
import persist from '@alpinejs/persist'


// optional
window.Alpine = Alpine;

//initialize Alpine
Alpine.plugin(persist);
Alpine.start();


